<div class="d-flex justify-content-between align-items-center w-100">
  <h1 *ngIf="options?.header" class="page-title">
    <fa-icon [icon]="options?.header?.icon"></fa-icon>
    {{ options?.header?.title | translate }}
  </h1>
  <ng-content select=".layout-header"></ng-content>
</div>

<div class="list-container"> 
  <div class="page-content" [ngClass]="!options?.header ? 'page-content-max' : ''">
    <div class="mt-10">
      <app-group-box
        [isHeaderVisible]="!!options?.card?.title"
        [pageTitle]="options?.card?.title | translate"
      >
        <div class="standard-padding">
          <ng-content select=".layout-body"></ng-content>
        </div>
      </app-group-box>
    </div>
  </div>
</div>